/* FN_W est publiee par layout/theme.liquid : elle redimensionne via le CDN
   Shopify (parametre width) ou via les variantes locales selon l'origine. */
var FN_W = window.FN_W || function (u, px) { return u; };

/* LE MUR — mur de produits 3D infini, shoppable */
(function () {
  const scene = document.querySelector('[data-mur-scene]');
  const plane = document.querySelector('[data-mur-plane]');
  const rows = Array.from(document.querySelectorAll('[data-mur-row]'));
  const list = (window.FN_PRODUCTS || []).filter(p => p && p.img);
  // variante WebP légère pour ces vignettes décoratives (repli auto si absente)
  const vignette = (el, src) => {
    const w = FN_W(src, 600);
    if (w === src) { el.src = src; return; }
    el.onerror = () => { el.onerror = null; el.src = src; };
    el.src = w;
  };

  if (!plane || !rows.length || !list.length) return;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;

  // mélange
  const pool = list.slice();
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }

  function tile(p) {
    const a = document.createElement('a');
    a.className = 'mur__tile';
    /* Meme correction que nouvelles.js : `/products/?handle=` ne mene nulle
       part sur Shopify, il faut `/products/<handle>` (2026-10-07). */
    a.href = p.url || ('/products/' + encodeURIComponent(p.handle));
    a.setAttribute('data-name', p.title || '');
    a.setAttribute('aria-label', p.title || 'Produit Fraise Noire');
    const img = document.createElement('img');
    vignette(img, p.img); img.alt = p.title || '';
    img.loading = 'lazy'; img.decoding = 'async';
    img.width = 238; img.height = 298;
    a.appendChild(img);
    return a;
  }

  /* ============================================================
     LE MUR NE SE CONSTRUIT QU'A L'APPROCHE
     ------------------------------------------------------------
     Il porte 150 images et se trouve a ~12 900 px du haut, soit
     quinze ecrans plus bas. Pourtant, mesure en 4G : 64 de ses
     images partaient des le chargement, 2 123 Ko qui volaient la
     bande passante a l'image du heros — laquelle mettait 6,2 s a
     s'afficher au lieu d'une seconde.

     `loading="lazy"` est pourtant bien pose sur chaque vignette
     (plus bas). Il ne protege rien ici : le plan est en
     `rotateX(17deg) scale(1.18)`, et un navigateur situe mal des
     images posees dans un plan 3D. Il les croit proches.

     La parade ne consiste donc pas a insister sur le lazy, mais a
     ne RIEN mettre dans le DOM tant que le mur n'approche pas.
     Benefice supplementaire : 300 elements de moins a construire
     au demarrage.
     ============================================================ */
  function construire() {
  // répartit le pool sur les 3 rangées
  const groups = [[], [], []];
  pool.forEach((p, i) => groups[i % 3].push(p));

  rows.forEach((rowEl, i) => {
    let g = groups[i];
    while (g.length < 8) g = g.concat(g);          // assez large pour couvrir l'écran
    // set + clone pour boucle sans couture (translateX -50%)
    [0, 1].forEach(() => g.forEach(p => rowEl.appendChild(tile(p))));
  });

  // parallaxe souris sur le plan
  if (scene && !reduce && fine) {
    const section = document.querySelector('.mur');
    const base = 'rotateX(17deg) rotateZ(-9deg) scale(1.18)';
    let raf = 0, tx = 0, ty = 0;
    section.addEventListener('mousemove', e => {
      const r = section.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    function apply() {
      raf = 0;
      plane.style.transform = `rotateX(${17 - ty * 7}deg) rotateZ(-9deg) rotateY(${tx * 8}deg) scale(1.18)`;
    }
    section.addEventListener('mouseleave', () => { plane.style.transform = base; });
  }

  // CTA magnétique
  const cta = document.querySelector('.mur [data-magnetic]');
  if (cta && !reduce && fine) {
    cta.addEventListener('mousemove', e => {
      const r = cta.getBoundingClientRect();
      const x = e.clientX - r.left - r.width / 2;
      const y = e.clientY - r.top - r.height / 2;
      cta.style.transform = `translate(${x * 0.28}px, ${y * 0.4}px)`;
    });
    cta.addEventListener('mouseleave', () => { cta.style.transform = ''; });
  }
  }   /* fin de construire() */

  /* On declenche deux ecrans avant : large de quoi que tout soit en place
     bien avant d'etre vu, sans rien couter au premier affichage.
     Sans IntersectionObserver, on construit tout de suite — mieux vaut une
     page lourde qu'une section vide. */
  const cible = document.querySelector('.mur') || plane;
  if ('IntersectionObserver' in window && cible) {
    const io = new IntersectionObserver(es => {
      if (!es.some(e => e.isIntersecting)) return;
      io.disconnect();
      construire();
    }, { rootMargin: '1600px 0px' });
    io.observe(cible);
  } else {
    construire();
  }
})();
